import _ from 'lodash';
import * as ActionTypes from '../actions/constants';

const invitationSteps = [
  {
    name: 'Front',
    to: 'detailFront',
    next: 'detailBack',
    cardType: 'INVITATION',
    pageNumber: 0
  },
  {
    name: 'Back',
    to: 'detailBack',
    next: 'recipients',
    cardType: 'INVITATION',
    pageNumber: 1
  },
  {
    name: 'Guests',
    to: 'recipients',
    next: 'addressing',
    cardType: 'RECIPIENTS'
  },
  // {
  //   name: 'Recipients',
  //   to: 'recipients',
  //   next: 'addressing',
  //   cardType: 'RECIPIENTS'
  // },
  {
    name: 'Addressing',
    to: 'addressing',
    next: 'rsvp',
    cardType: 'ADDRESSING'
  },
  {
    name: 'RSVP Card',
    to: 'rsvp',
    next: 'rsvpEnvelope',
    cardType: 'RSVP',
    pageNumber: 0
  },
  {
    name: 'RSVP Envelope',
    to: 'rsvpEnvelope',
    next: 'envelope',
    cardType: 'RSVP_ENVELOPE',
    pageNumber: 0
  },
  {
    name: 'Envelope',
    to: 'envelope',
    next: 'reviewPaper',
    cardType: 'INVITATION_ENVELOPE',
    pageNumber: 0
  },
  {
    name: 'Review',
    to: 'reviewPaper'
  }
];

const letterSTDSteps = [
  {
    name: 'Front',
    to: 'detailFront',
    next: 'detailBack',
    cardType: 'SAVE_THE_DATE',
    pageNumber: 0
  },
  {
    name: 'Back',
    to: 'detailBack',
    next: 'recipients',
    cardType: 'SAVE_THE_DATE',
    pageNumber: 1
  },
  {
    name: 'Guests',
    to: 'recipients',
    next: 'addressing',
    cardType: 'RECIPIENTS'
  },
  {
    name: 'Addressing',
    to: 'addressing',
    next: 'envelope',
    cardType: 'ADDRESSING'
  },
  {
    name: 'Envelope',
    to: 'envelope',
    next: 'reviewPaper',
    cardType: 'INVITATION_ENVELOPE',
    pageNumber: 0
  },
  {
    name: 'Review',
    to: 'reviewPaper'
  }
];

const postcardSTDSteps = [
  {
    name: 'Front',
    to: 'detailFront',
    next: 'detailBack',
    cardType: 'SAVE_THE_DATE',
    pageNumber: 0
  },
  {
    name: 'Back',
    to: 'detailBack',
    next: 'recipients',
    cardType: 'SAVE_THE_DATE',
    pageNumber: 1
  },
  {
    name: 'Guests',
    to: 'recipients',
    next: 'addressing',
    customizationName: 'RECIPIENTS'
  },
  {
    name: 'Addressing',
    to: 'addressing',
    next: 'reviewPaper',
    customizationName: 'ADDRESSING'
  },
  {
    name: 'Review',
    to: 'reviewPaper'
  }
];

let saveTheDateSteps;

const initialState = {
  activeCardEvent: '', // std, invitation , this should leave empty init state because url will decide
  projectId: '', // each card type flow of all formats is one project
  splitOrderId: null,
  projectType: null,
  productId: '',
  skuId: '',
  orderView: [],
  steps: {},
  currentStep: null,
  maxStepIndex: 0,
  maxStep: null,
  quantity: 0,
  size: '',
};

export default function projectReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ActionTypes.SELECT_EVENT_TYPE: {
      return Object.assign({}, state, { activeCardEvent: action.payload });
    }
    case ActionTypes.SELECT_FORM_TYPE: {
      return Object.assign({}, state, { activeCardForm: action.payload });
    }
    case ActionTypes.SELECT_WRAP_TYPE: {
      return Object.assign({}, state, { activeCardWrap: action.payload });
    }
    case ActionTypes.RECEIVE_PROJECT: {
      const { project } = action.payload;
      let isPostcard;
      const projectType = (_.findIndex(project.customization_templates, { card_type: 'INVITATION' }) > -1) ? 'INVITATION' : 'SAVE_THE_DATE';
      const stdProject = _.find(project.customization_templates, {
        card_type: 'SAVE_THE_DATE',
      });
      let steps;
      if (projectType === 'INVITATION') {
        steps = invitationSteps.reduce((result, step) => {
          result.orderedItems.push(step.to);
          result[step.to] = step; // eslint-disable-line
          return result;
        }, { orderedItems: [] });
      } else {
        isPostcard = stdProject.project_customization.sku_view.product_option_values.size === 'postcard';
        saveTheDateSteps = isPostcard ? postcardSTDSteps : letterSTDSteps;
        steps = saveTheDateSteps.reduce((result, step) => {
          result.orderedItems.push(step.to);
          result[step.to] = step; // eslint-disable-line
          return result;
        }, { orderedItems: [] });
      }

      const editedCustomizations = [];
      project.customization_templates.forEach((customizationTemplate) => { // eslint-disable-line
        const cardType = customizationTemplate.card_type;
        const editedAt = customizationTemplate.project_customization.edited_at;
        if (editedAt !== null) {
          editedCustomizations.push({ [cardType]: editedAt });
        }
      });

      const size = isPostcard ? 'postcard' : projectType === 'INVITATION' ? '5x7' : 'petite';  //eslint-disable-line

      // let maxStep;
      // if (editedCustomizations.length === 0) {
      //   maxStep = null;
      // } else if (editedCustomizations.length === project.customization_templates.length) {
      //   maxStep = 'reviewPaper';
      // } else {

      // }
      let maxStep;
      if (project.project_uuid !== state.projectId) {
        maxStep = null;
      } else {
        maxStep = state.maxStep;
      }

      const images = _.flatMap(project.customization_templates, (customization) => { // eslint-disable-line
        return customization.project_customization.renders.map(image => ({ cardType: customization.card_type, ...image }));
      });
      // console.log('PROJECT IMAGES: ', images);
      const splitOrderId = project.split_order_id ? project.split_order_id : null;
      return { ...state, projectType, projectId: project.project_uuid, splitOrderId, steps, images, maxStep, size };
    }
    case ActionTypes.SET_PROJECT_UUID: {
      return Object.assign({}, state, { projectId: action.payload.projectId });
    }
    case ActionTypes.SET_PROJECT_TYPE: {
      const { projectType } = action.payload;
      return { ...state, projectType };
    }
    // case ActionTypes.SET_CUSTOMIZATION_UUID: {
    //   return Object.assign({}, state, {
    //     invitationCustomizationUUID: action.payload.invitationCustomizationUUID,
    //     rsvpCustomizationUUID: action.payload.rsvpCustomizationUUID,
    //     rsvpEnvelopeCustomizationUUID: action.payload.rsvpEnvelopeCustomizationUUID,
    //     envelopeCustomizationUUID: action.payload.envelopeCustomizationUUID,
    //   });
    // }
    case ActionTypes.SET_SKU_ID: {
      return Object.assign({}, state, { skuId: action.payload });
    }
    case ActionTypes.SET_PRODUCT_ID: {
      return { ...state, productId: action.payload };
    }
    // case ActionTypes.SAVE_PROJECT_SUCCESS: {
    //   return {
    //     ...state,
    //     projects: {
    //       ...state.projects,
    //       [action.projectId]: {
    //         ...state.projects[action.projectId],
    //         skuId: action.skuId,
    //       }
    //     }
    //   };
    // }
    case ActionTypes.RECEIVE_PROJECT_ORDER_VIEW: {
      const orderView = action.payload.customizations
        .map(customization => ({
          displayOrder: customization.display_order,
          customizationUUID: customization.project_customization_uuid,
          name: customization.name,
          quantity: customization.quantity,
          priceCents: customization.sku_view.price_cents,
          imageUrls: customization.sku_view.image_urls,
          color: customization.sku_view.product_option_values.color,
          colorLabel: customization.sku_view.product_option_value_labels ? customization.sku_view.product_option_value_labels.color : customization.sku_view.product_option_values.color,
          paperType: customization.sku_view.product_option_values['paper-type'],
          shape: customization.sku_view.product_option_values.silhouette,
          size: customization.sku_view.product_option_values.size,
          type: customization.type,
          liningColor: customization.sku_view.product_option_value_labels ? customization.sku_view.product_option_value_labels['envelope-lining-color'] : null
        }))
        .sort((a, b) => a.displayOrder - b.displayOrder);
      return { ...state, orderView };
    }
    // case ActionTypes.SET_COMPLETED_MENU: {
    //   return Object.assign({}, state, { completedMenu: action.payload });
    // }
    case ActionTypes.SELECT_QUANTITY: {
      return Object.assign({}, state, { quantity: action.quantity });
    }
    case ActionTypes.SELECT_SIZE: {
      return Object.assign({}, state, { size: action.size });
    }
    case ActionTypes.SET_CURRENT_STEP: {
      const { step } = action.payload;
      let currentStepIndex;
      if (state.projectType === 'INVITATION') {
        currentStepIndex = _.findIndex(invitationSteps, { to: step });
      } else {
        currentStepIndex = _.findIndex(saveTheDateSteps, { to: step });
      }
      let maxStep;
      let maxStepIndex;
      if (!state.maxStep) {
        maxStepIndex = currentStepIndex;
        maxStep = step;
      } else {
        maxStepIndex = currentStepIndex > state.maxStepIndex ? currentStepIndex : state.maxStepIndex;
        if (state.projectType === 'INVITATION') {
          maxStep = invitationSteps[maxStepIndex].to;
        } else {
          maxStep = saveTheDateSteps[maxStepIndex].to;
        }
      }
      return { ...state, currentStep: step, maxStep, maxStepIndex };
    }
    case ActionTypes.SET_ACTIVE_SKU: {
      return Object.assign({}, state, { activeSku: action.sku });
    }
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/cards/reducers/project.js
 **/